module.exports = __webpack_public_path__ + "img/bg_resize_fg_grass_1.337b5bc0.png";